import {
    Color,
    LinearMipMapLinearFilter,
    Mesh,
    MeshBasicMaterial,
    NormalBlending,
    SphereGeometry,
    Sprite,
    SpriteMaterial,
    TextureLoader,
    Vector3
} from 'da-three';

// let this be global, no need to reload the tex every
// but it has to be refactored -> global textureloader/lib?
let texLoader = new TextureLoader();
texLoader.crossOrigin = " ";
let simpleTransTex;
let simpleTransHoverTex;
let actionTransTex;
let actionTransHoverTex;

function initTextures(basedir) {
    if (simpleTransTex === undefined && simpleTransHoverTex === undefined) {
        simpleTransTex = texLoader.load(basedir+'textures/highlight/simple_trans.png');
        simpleTransHoverTex = texLoader.load(basedir+'textures/highlight/simple_trans_hover.png');
        
        actionTransTex = texLoader.load(basedir+'textures/highlight/action_trans.png');
        actionTransHoverTex = texLoader.load(basedir+'textures/highlight/action_trans_hover.png');
    }
}

export default class Highlight {
    constructor(highData,basedir,group){
        this.headline       = highData.headline;
        this.content        = highData.content;
        this.position       = new Vector3(highData.pos.x,highData.pos.y,highData.pos.z);
        this.cameraTarget   = new Vector3(highData.cam.x,highData.cam.y,highData.cam.z);
        this.target         = new Vector3(highData.target.x, highData.target.y, highData.target.z);
        this.fov            = highData.fov; 

        this.parent         = group;
        this.id             = highData.id;
        this.scale = highData.scale;
        this.color = highData.color;
        this.speed = highData.speed;
        this.style = highData.style;
        this.data = highData.data;
        this.mount = {
            name: highData.mount,
            element: null
        };
        this.clickzone      = this.initClickzone();
        this.glow           = this.initGlow(highData.color,basedir);
        this.nodes          = [];
        let scope = this;
        this.glow.scale.x = this.scale;
        this.glow.scale.y = this.scale;
        this.glow.scale.z = this.scale;
        this.clickzone.scale.x = this.scale;
        this.clickzone.scale.y = this.scale;
        this.clickzone.scale.z = this.scale;
        this.isTrigger = highData.isTrigger;
        this.hover = false;
        group.traverse(function(node){

            const nodeName = node.name.trim();
            if (nodeName.length > 0) {
                if(node instanceof Mesh && highData.nodes.indexOf(node.name) > -1) {
                    scope.nodes.push(node);
                }

                if(!scope.mount.element && scope.mount.name && nodeName === scope.mount.name) {
                    scope.mount.element = node;

                    // initial position
                    const wp = scope.getWorldPosition(node);
                    scope.mount.relativeTransform = scope.getWorldPosition(scope.clickzone).sub(wp);
                    console.log("Relative Transform", scope.mount.relativeTransform, "position of object", wp, "hl pos", scope.position, scope.getWorldPosition(scope.clickzone));
                }
            }
        });

        // hl animations
        if (highData.animation) {
            this.animation = highData.animation
        }

        if (highData.visibility) {
            this.visibility = highData.visibility;
        }
        
        this.clickzone.add(this.glow);
        this.parent.add(this.clickzone);
    }

    getWorldPosition(node) {
        node.updateMatrix();
        const wp = new Vector3();
        wp.setFromMatrixPosition(node.matrix);

        return wp;
    }

    updateMountedPosition() {
        console.log("Before!!", this.clickzone.position.clone());
        const node = this.mount.element;
        node.updateMatrix();
        const wp = new Vector3();
        wp.setFromMatrixPosition(node.matrix);
        
        console.log(wp.add(this.mount.relativeTransform));

        //this.clickzone.position.copy(wp.add(this.mount.relativeTransform));
    }


    getCameraTarget(){
        return this.cameraTarget;
    }



    getPosition(){
        return this.position;
    }

    

    getViewTarget () {
        return (new Vector3(this.target.x, this.target.y, this.target.z));
    }



    getFov() {
        return this.fov;
    }
    
    
    
    initClickzone(){
        let wFrame = new MeshBasicMaterial({ 
            color: 0xffffff, 
            wireframe: true, 
            transparent: true,
            opacity: 0,
            visible: false
        });

        let sp1g = new SphereGeometry(0.15, 20, 20);
        let sphere = new Mesh(sp1g, wFrame);
        sphere.position.copy(this.position);
        sphere.scale.set(this.scale,this.scale,this.scale);

        //Add rotation targets to sphere
        sphere.camX = this.cameraTarget.x;
        sphere.camY = this.cameraTarget.y;
        sphere.camZ = this.cameraTarget.z;

        return sphere;
    }
    
    
    
    initGlow(color, basedir) {
        initTextures(basedir);

        let spriteMaterial = new SpriteMaterial({ 
            map: this.isTrigger ? actionTransTex : simpleTransTex, 
            //useScreenCoordinates: false, 
            //alignment: THREE.SpriteAlignment.center,
            color: 0xffffff, 
            transparent: true, 
            blending: NormalBlending
        });
        spriteMaterial.map.magFilter = LinearMipMapLinearFilter;
        spriteMaterial.map.minFilter = LinearMipMapLinearFilter;

        let sprite = new Sprite( spriteMaterial );		
        if (color !== undefined){
            sprite.material.color = new Color(parseInt((''+color).replace("#", "0x"),16));
        }

        return sprite;
    }
    
    
    
    remove(){
        this.clickzone.remove(this.glow);
        this.parent.remove(this.clickzone);
    }
    
    
    
    setCameraTarget(position){
        this.cameraTarget = position;
    }
    
    
    
    setColor(color){
        this.glow.material.color.setHex(parseInt(color.replace("#", "0x"),16));
        this.glow.material.needsUpdate = true;
    }



    setFov(nf) {
        this.fov = nf;
    }
    
    
    
    setHover(state) {
        if (this.hover !== state) {
            this.hover = state;
            
            if (this.hover) {
                this.glow.material.map = this.isTrigger ? actionTransHoverTex : simpleTransHoverTex;
            } else {
                this.glow.material.map = this.isTrigger ? actionTransTex: simpleTransTex;
            }
            
        }
    }
    
    
    
    setPosition(position){
        this.position = position;
        this.clickzone.position.copy(position);
    }
    
    

    setProperty(property,value){
        switch(property){
            case 'camx':
                this.cameraTarget.x = value;
                break;
            case 'camy':
                this.cameraTarget.y = value;
                break;
            case 'camz':
                this.cameraTarget.z = value;
                break;
            case 'color':
                this.setColor(value);
                break;
            case 'content':
                this.content = value;
                break;
            case 'headline':
                this.headline = value;
                break;
            case 'posx':
                this.position.x = value;
                this.clickzone.position.setX(this.position.x);
                break;
            case 'posy':
                this.position.y = value;
                this.clickzone.position.setY(this.position.y);
                break;
            case 'posz':
                this.position.z = value;
                this.clickzone.position.setZ(this.position.z);
                break;
            case 'scale':
                this.scale = value;
                this.clickzone.scale.set(this.scale,this.scale,this.scale);
                break;
            case 'isTrigger':
                this.isTrigger = value;
                break;
            default:
                break;    
        }
    }
    
    
    
    setViewTarget(nt) {
        this.target = new Vector3(nt.x, nt.y, nt.z);
    }



    updateID(newID){
        this.id = newID;
    }
};


// WEBPACK FOOTER //
// ./src/js/studio/model/Highlight.js